export enum ERoute {
  UserLogin = '/user/login',
  UserSignup = '/user/signup',
  UserSignupCompleted = '/user/signup_completed',
  UserEdit = '/user/edit',
  UserPasswordReset = '/user/password_reset',
  UserActivate = '/user/activate',
  UserCredit = '/user/credit',
  UserCourseUsageHistory = '/user/credit/history',
  UserCreditExchange = '/user/credit_exchange',
  UserCreditExchangeRequest = '/user/credit_exchange_request',
  PasswordUpdate = '/password/update',
  MentorVerification = '/mentor/verification',
  VerificationEmail = '/verification/email',
  MentoringAbout = '/mentoring/about',
  MentoringCreditPrice = '/mentoring/program_about',
  MentoringCreditPurchase = '/mentoring/credit_purchase',
  MentoringCreditPurchaseCompleted = '/mentoring/credit_purchase_completed',
  MentoringMyPage = '/mentoring/my_page',
  MentoringMyMentee = '/mentoring/my_mentee',
  MentoringMentorList = '/mentoring/mentor_list',

  MentoringMentorView = '/mentoring/mentor_view/:record_id',
  MentoringMenteeView = '/mentoring/mentee_view/:record_id',
  MentoringClassCreate = '/mentoring/mentor_view/:record_id/class_create',

  MentoringClassView = '/mentoring/class_view/:record_id',
  MentoringFeedback = '/mentoring/feedback',
  MentoringReview = '/mentoring/review',
  MentoringProgramAbout = '/mentoring/program_about',
  MentoringDashboard = '/mentoring/dashboard',
  // qna
  MentoringQNA = '/mentoring/qna',
  MentoringQNADetail = '/mentoring/qna/:id',
  MentoringQNAWrite = '/mentoring/qna/write',
  CompanyJobOpening = '/company/job_opening',
  CompanyTurnOver = '/company/turnover/',
  CompanyFulltime = '/company/fulltime/',
  CompanyParttime = '/company/parttime/',
  CompanyTurnOverView = '/company/turnover/view/:record_id',
  CompanyFulltimeView = '/company/fulltime/view/:record_id',
  CompanyParttimeView = '/company/parttime/view/:record_id',
  IntroductionQuestion = '/introduction/question',
  IntroductionAnnouncement = '/introduction/announcement',
  IntroductionCustomerInquiry = '/introduction/customer_inquiry',
  IntroductionLanding = '/introduction/landing',
  IntroductionReview = '/introduction/review',
  CompanySearch = '/cslab/search/',
  CSLabMentorFinder = '/cslab/mentor_finder',
  //왼쪽 내브바가 아닌 유저 드롭 다운 메뉴로 이동
  //CSLabSwitchToMentor = "/cslab/switch_to_mentor",
  CSLabSwitchToMentor = '/user/switch_to_mentor',
  CSLabBoard = '/cslab/board',
  CSWebinar = '/cslab/webinar',
  CompanyInternView = '/cslab/intern_view/:record_id', // 우선 cslab으로 변경
  CompanyInternFinder = '/cslab/intern_finder',
  CaseIntroduction = '/case/introduction',
  CaseBoard = '/case/board',
  CaseItem = '/case/board/:id',
  CaseLibrary = '/case/library',
  CaseLibraryDetail = '/case/library/:id',
  CaseLibraryWrite = '/case/library/write',
  CaseLibraryItem = '/case/library/:id',
  CaseDetail = '/case/board/:id/:detail_type/:detail_id',
  CaseWrite = '/case/board/:id/write',
  CaseWriteEdit = '/case/board/:id/write/:detail_id',
  Purchase = '/purchase/:type',
  PurchaseComplete = '/purchase/complete/:type/:id',
  //boardframework
  CSLearningBoard = '/case/framework', //(주제)  주제 선택 페이지
  CSLearningSubcategory = '/case/framework/:category/:operation', //(소주제)  or '/learning/case_interview'(주제 별 서브 카테고리 페이지 가 다를 경우 )  주제 선택하여 들어가면 나오는 서브 카테고리 페이지
  CSLearningExplain = '/case/framework/:category/:step_id/:operation', //(소주제 설명) 소주제 별 설명 페이지 - 뒤에 :operation (create/view/edit)
  CSLearningExample = '/case/framework/:category/:step_id/:example_id/:operation', // (소주제에 대한 예제 설명 페이지) - 뒤에 :operation  (create/view/edit)
  //quiz
  CSLearningQuizList = '/case/quizzes',
  CSLearningQuiz = '/case/quiz',
  CSLearningPurchaseGuide = '/case/quiz/membership_introduction',
  CSLearningPurchasePage = '/purchase/exercise_membership',
  //community
  //면접 후기
  InterviewReviewBoard = '/community/interview_review',
  InterviewReviewWrite = '/community/interview_review/:operation',
  //최종합격 후기
  FinalAcceptanceBoard = '/community/final_acceptance',
  FinalAcceptanceDetail = '/community/final_acceptance/:id',
  FinalAcceptanceWrite = '/community/final_acceptance/write',

  //Excel 강의
  ExcelClassList = '/cslab/excel_class_list',
  ExcelClassPlayer = '/cslab/excel_class_player/:id',

  // 전략컨설팅 인터뷰 MasterClass (기초퍈) 강의 소개
  LectureInterviewMasterClassBasic = '/lectures/interview-master-class-basic',
  LectureInterviewMasterClassBasicVideoPlayer = '/lectures/interview-master-class-basic/player',

  // 개인정보정책
  PrivacyPolicy = '/privacypolicy',

  //멘토링&p2p 수업 참여
  MentoringJoinLanding = '/course',
  MentoringJoinCallView = '/direct-call',
  CaseroomJoin = '/course/caseroom/:id',

  // Kaitus addition
  KaitusLogin = '/kaitus/:tenant_id/login',
  KaitusWelcome = '/kaitus/:tenant_id/welcome',
  KaitusAssessment = '/kaitus/:tenant_id/assessment',
  KaitusAssessmentDetail = '/kaitus/:tenant_id/assessment/item',
  KaitusComplete = '/kaitus/:tenant_id/complete',
}
